import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';
import { Entry } from 'contentful';
import { ImageContentType } from '@nibtravel/shared/ui/components/picture';

/** Generic Hero */
@Component({
  selector: 'nibtravel-hero',
  templateUrl: './hero.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeroComponent {
  @HostBinding('class') classes = 'hero';

  /** The hero title */
  @Input() title!: string;

  /** The lead hero paragraph */
  @Input() leadText!: string;

  /** The image to be shown */
  @Input() imageMobile: string | Entry<ImageContentType> | undefined;
  @Input() imageLowResolution: string | Entry<ImageContentType> | undefined;
  @Input() imageHighResolution: string | Entry<ImageContentType> | undefined;
}
